// Generated with util/create-component.js
import Input from './Input';

export default Input;
